import { $customers } from './customers'

export class Dummy {
  static customers = $customers
}
